"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _icon = _interopRequireDefault(require("@clayui/icon"));
var _layout = _interopRequireDefault(require("@clayui/layout"));
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireDefault(require("react"));
var _Footer = require("./Footer");
var _ToastContainer = require("./ToastContainer");
var _excluded = ["actions", "autoClose", "children", "className", "displayType", "hideCloseIcon", "onClose", "role", "spritemap", "symbol", "title", "variant"];
/**
 * SPDX-FileCopyrightText: © 2019 Liferay, Inc. <https://liferay.com>
 * SPDX-License-Identifier: BSD-3-Clause
 */
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) { o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } } return t; }
var useAutoClose = function useAutoClose(autoClose) {
  var onClose = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
  var startedTime = _react.default.useRef(0);
  var timer = _react.default.useRef(undefined);
  var timeToClose = _react.default.useRef(autoClose === true ? 10000 : autoClose);
  var pauseTimer = function pauseTimer() {};
  var startTimer = function startTimer() {};
  if (autoClose) {
    pauseTimer = function pauseTimer() {
      if (timer.current) {
        timeToClose.current = timeToClose.current - (Date.now() - startedTime.current);
        clearTimeout(timer.current);
        timer.current = undefined;
      }
    };
    startTimer = function startTimer() {
      startedTime.current = Date.now();
      timer.current = window.setTimeout(onClose, timeToClose.current);
    };
  }
  _react.default.useEffect(function () {
    if (autoClose) {
      startTimer();
      return pauseTimer;
    }
  }, []);
  return {
    pauseAutoCloseTimer: pauseTimer,
    startAutoCloseTimer: startTimer
  };
};
var ICON_MAP = {
  danger: 'exclamation-full',
  info: 'info-circle',
  secondary: 'password-policies',
  success: 'check-circle-full',
  warning: 'warning-full'
};
var VARIANTS = ['inline', 'feedback'];
var ClayAlert = function ClayAlert(_ref) {
  var actions = _ref.actions,
    autoClose = _ref.autoClose,
    children = _ref.children,
    className = _ref.className,
    _ref$displayType = _ref.displayType,
    displayType = _ref$displayType === void 0 ? 'info' : _ref$displayType,
    _ref$hideCloseIcon = _ref.hideCloseIcon,
    hideCloseIcon = _ref$hideCloseIcon === void 0 ? false : _ref$hideCloseIcon,
    onClose = _ref.onClose,
    _ref$role = _ref.role,
    role = _ref$role === void 0 ? 'alert' : _ref$role,
    spritemap = _ref.spritemap,
    symbol = _ref.symbol,
    title = _ref.title,
    variant = _ref.variant,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var _useAutoClose = useAutoClose(autoClose, onClose),
    pauseAutoCloseTimer = _useAutoClose.pauseAutoCloseTimer,
    startAutoCloseTimer = _useAutoClose.startAutoCloseTimer;
  var ConditionalContainer = function ConditionalContainer(_ref2) {
    var children = _ref2.children;
    return variant === 'stripe' ? /*#__PURE__*/_react.default.createElement("div", {
      className: "container"
    }, children) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, children);
  };
  var showDismissible = onClose && !hideCloseIcon;
  var AlertIndicator = function AlertIndicator() {
    return /*#__PURE__*/_react.default.createElement("span", {
      className: "alert-indicator"
    }, /*#__PURE__*/_react.default.createElement(_icon.default, {
      spritemap: spritemap,
      symbol: symbol || ICON_MAP[displayType]
    }));
  };
  return /*#__PURE__*/_react.default.createElement("div", _extends({}, otherProps, {
    className: (0, _classnames.default)(className, 'alert', _defineProperty({
      'alert-dismissible': showDismissible,
      'alert-feedback alert-indicator-start': variant === 'feedback',
      'alert-fluid': variant === 'stripe',
      'alert-inline': variant === 'inline'
    }, "alert-".concat(displayType), displayType)),
    onMouseOut: startAutoCloseTimer,
    onMouseOver: pauseAutoCloseTimer
  }), /*#__PURE__*/_react.default.createElement(ConditionalContainer, null, /*#__PURE__*/_react.default.createElement(_layout.default.ContentRow, {
    className: "alert-autofit-row",
    role: role
  }, !VARIANTS.includes(variant) && /*#__PURE__*/_react.default.createElement(_layout.default.ContentCol, null, /*#__PURE__*/_react.default.createElement(_layout.default.ContentSection, null, /*#__PURE__*/_react.default.createElement(AlertIndicator, null))), /*#__PURE__*/_react.default.createElement(_layout.default.ContentCol, {
    expand: true
  }, /*#__PURE__*/_react.default.createElement(_layout.default.ContentSection, null, VARIANTS.includes(variant) && /*#__PURE__*/_react.default.createElement(AlertIndicator, null), title && /*#__PURE__*/_react.default.createElement("strong", {
    className: "lead"
  }, title), children, variant !== 'inline' && actions && /*#__PURE__*/_react.default.createElement(_Footer.ClayAlertFooter, null, actions))), variant === 'inline' && actions && /*#__PURE__*/_react.default.createElement(_layout.default.ContentCol, null, /*#__PURE__*/_react.default.createElement(_layout.default.ContentSection, null, actions))), showDismissible && /*#__PURE__*/_react.default.createElement("button", {
    "aria-label": "Close",
    className: "close",
    onClick: onClose,
    type: "button"
  }, /*#__PURE__*/_react.default.createElement(_icon.default, {
    spritemap: spritemap,
    symbol: "times"
  }))));
};
ClayAlert.displayName = 'ClayAlert';
ClayAlert.Footer = _Footer.ClayAlertFooter;
ClayAlert.ToastContainer = _ToastContainer.ClayToastContainer;
var _default = exports.default = ClayAlert;